var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.414 5.758l-1.172-1.172A1.992 1.992 0 0016.828 4c-.512 0-1.024.195-1.415.586L4.402 15.598l-.397 3.569a.75.75 0 00.828.828l3.566-.394L19.414 8.586a2 2 0 000-2.828zM7.94 18.646l-2.907.322.324-2.911 8.246-8.247 2.587 2.587-8.25 8.25zM18.707 7.88l-1.81 1.81-2.587-2.586 1.81-1.81A.994.994 0 0116.829 5c.267 0 .518.104.707.293l1.172 1.172a1 1 0 010 1.414z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit-pencil.85da273acb339f091e9f781cbc7be99c.svg";
export { ForwardRef as ReactComponent };